// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.details-container {
  height: calc(100vh - 93px);
  background-color: white;
}
.details-container .company-details {
  padding: 10px;
  display: flex;
}
.details-container .company-details .company-box {
  min-width: 169px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid rgb(221, 221, 221);
}
.details-container .company-details .company-box .company-box-logo {
  width: 150px;
  height: 150px;
  object-fit: contain;
}
.details-container .company-details .company-form {
  float: right;
  width: 100%;
}
.details-container .company-details .company-form .company-actions {
  display: flex;
  justify-content: flex-end;
  padding: 5px;
  margin: 10px 0;
  border: 1px solid rgb(221, 221, 221);
}
.details-container .facility-details {
  padding: 10px;
  display: flex;
  height: calc(100% - 308px);
}
.details-container .facility-details .facility-list {
  border-bottom: 1px solid rgb(221, 221, 221);
}
.details-container .facility-details .facility-data {
  width: 100%;
  border-bottom: 1px solid rgb(221, 221, 221);
}
.details-container .facility-details .facility-data .facility-actions {
  display: flex;
  justify-content: flex-end;
  padding: 5px;
  margin: 10px 0;
  border: 1px solid rgb(221, 221, 221);
}
.details-container .facility-details .facility-data .specialization-container {
  display: flex;
  position: relative;
  height: 250px;
  width: 100%;
}
.details-container .facility-details .facility-data .specialization-container .specialization-content {
  width: calc(100% - 400px);
  border: 1px solid rgb(221, 221, 221);
}

.details-vr-line {
  background-color: rgb(221, 221, 221);
  border-bottom: 1px solid rgb(221, 221, 221);
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/view/admin/company-details/company-details.component.scss"],"names":[],"mappings":"AAAA;EACI,0BAAA;EACA,uBAAA;AACJ;AACI;EACI,aAAA;EACA,aAAA;AACR;AACQ;EACI,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;AACZ;AACY;EACI,YAAA;EACA,aAAA;EACA,mBAAA;AAChB;AAGQ;EACI,YAAA;EACA,WAAA;AADZ;AAGY;EACI,aAAA;EACA,yBAAA;EACA,YAAA;EACA,cAAA;EACA,oCAAA;AADhB;AAMI;EACI,aAAA;EACA,aAAA;EACA,0BAAA;AAJR;AAMQ;EACI,2CAAA;AAJZ;AAOQ;EACI,WAAA;EACA,2CAAA;AALZ;AAOY;EACI,aAAA;EACA,yBAAA;EACA,YAAA;EACA,cAAA;EACA,oCAAA;AALhB;AAQY;EACI,aAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;AANhB;AAQgB;EACI,yBAAA;EACA,oCAAA;AANpB;;AAaA;EACI,oCAAA;EACA,2CAAA;EACA,WAAA;AAVJ","sourcesContent":[".details-container {\n    height: calc(100vh - 93px);\n    background-color: white;\n\n    .company-details {\n        padding: 10px;\n        display: flex;\n\n        .company-box {\n            min-width: 169px;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            border: 1px solid rgba(221, 221, 221, 1);\n\n            .company-box-logo {\n                width: 150px;\n                height: 150px;\n                object-fit: contain;\n            }\n        }\n\n        .company-form {\n            float: right;\n            width: 100%;\n\n            .company-actions {\n                display: flex;\n                justify-content: flex-end;\n                padding: 5px;\n                margin: 10px 0;\n                border: 1px solid rgba(221, 221, 221, 1);\n            }\n        }\n    }\n\n    .facility-details {\n        padding: 10px;\n        display: flex;\n        height: calc(100% - 308px);\n\n        .facility-list {\n            border-bottom: 1px solid rgba(221, 221, 221, 1);\n        }\n\n        .facility-data {\n            width: 100%;\n            border-bottom: 1px solid rgba(221, 221, 221, 1);\n\n            .facility-actions {\n                display: flex;\n                justify-content: flex-end;\n                padding: 5px;\n                margin: 10px 0;\n                border: 1px solid rgba(221, 221, 221, 1);\n            }\n\n            .specialization-container {\n                display: flex;\n                position: relative;\n                height: 250px;\n                width: 100%;\n\n                .specialization-content {\n                    width: calc(100% - 400px);\n                    border: 1px solid rgba(221, 221, 221, 1);\n                }\n            }\n        }\n    }\n}\n\n.details-vr-line {\n    background-color: rgba(221, 221, 221, 1);\n    border-bottom: 1px solid rgba(221, 221, 221, 1);\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
